import {
    Breakpoints,
    CTA,
    Text,
    TextTag,
    TokenTextColor,
} from '@volkswagen-onehub/components-core'
import styled from 'styled-components'
import React, {useEffect} from 'react'
import BreadcrumbsCommon from '../../../common/components/breadcrumbs/BreadcrumbsCommon'
import BreadcrumbsInterface from '../../../types/BreadcrumbsInterface'

interface BreadcrumbsProps {
    list: BreadcrumbsInterface[]
    onBack?: () => void
}

function isLastInList(arrLen: number, idx: number): boolean {
    return idx === arrLen - 1
}

const BreadcrumbsList = styled.ol`
    display: none;
    list-style: none;
    padding: 0;
    margin: 0;
    color: ${(props) => props.theme.colors.content.secondary};

    @media (min-width: ${Breakpoints.b560}px) {
        display: flex;
        flex-wrap: wrap;
        padding: 0px;
        margin: 0 ${(props) => props.theme.size.grid002};
    }

    @media (min-width: ${Breakpoints.b1280}px) {
        max-width: 50vw;
    }
`

const BreadcrumbsListItem = styled.li`
    --breadcrumb-list-item-gutter: 8px;

    display: inline-flex;
    align-items: center;
    font-size: 16px;
    line-height: 1;
    margin-right: var(--breadcrumb-list-item-gutter);
    margin-bottom: var(--breadcrumb-list-item-gutter);

    :not(:first-child) {
        &::before {
            content: '';
            margin-right: 8px;
            width: 0;
            height: 0;
            border-left: 0.4em solid
                ${(props) => props.theme.colors.content.active};
            border-top: 0.25em solid transparent;
            border-bottom: 0.25em solid transparent;
        }
    }

    a {
        &,
        span {
            text-decoration: none;
        }
    }
`

export default function Breadcrumbs(
    props: BreadcrumbsProps
): React.JSX.Element {
    useEffect(() => {
        if (typeof props.onBack === 'undefined') {
            return
        }

        window.addEventListener(
            'popstate',
            () => {
                // check for undefined callback is done before the event listener is added
                props.onBack?.()
            },
            false
        )
    }, [])

    return (
        <BreadcrumbsList>
            {props.list.map((breadcrumbElement: BreadcrumbsInterface, i) => (
                <BreadcrumbsListItem key={i}>
                    {breadcrumbElement.href &&
                    !isLastInList(props.list.length, i) ? (
                        <CTA
                            tag={'a'}
                            emphasis="tertiary"
                            href={
                                breadcrumbElement.href ===
                                BreadcrumbsCommon.PROGRAMMATIC_NAVIGATION_LINK
                                    ? undefined
                                    : breadcrumbElement.href
                            }
                            aria-label={breadcrumbElement.label}
                            onClick={() => {
                                if (
                                    typeof breadcrumbElement.onClick !==
                                    'undefined'
                                ) {
                                    breadcrumbElement.onClick()
                                }
                            }}
                        >
                            {breadcrumbElement.label}
                        </CTA>
                    ) : (
                        <Text
                            bold
                            tag={TextTag.span}
                            color={TokenTextColor.primary}
                        >
                            {breadcrumbElement.label}
                        </Text>
                    )}
                </BreadcrumbsListItem>
            ))}
        </BreadcrumbsList>
    )
}
